import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
  FaFileContract,
  FaClipboardList,
  FaSignature,
  FaLock,
  FaInfoCircle,
  FaChevronRight,
  FaLockOpen
} from "react-icons/fa";

import styles from "./Menu.module.css";
import { getPermisoId } from "../../../redux/actions";

const RegistroYControl = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const permisoUser = useSelector((state) => state.permisouser);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");

    if (userId) {
      dispatch(getPermisoId(userId)).finally(() =>
        setTimeout(() => setLoading(false), 300)
      );
    }
  }, [dispatch]);

  const validar = (permiso, ruta) => {
    if (permiso === 1) {
      navigate(ruta);
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Acceso Restringido",
      html: `
        <div style="font-family: 'Inter', sans-serif;">
          <p>Este módulo requiere privilegios adicionales.</p>
          <small style="color: #8b949e;">Comuníquese con el administrador para solicitar acceso.</small>
        </div>
      `,
      confirmButtonText: "Entendido",
      confirmButtonColor: "#0081cf",
      background: "#0a0e14",
      color: "#f0f6fc",
    });
  };

  const cards = [
    {
      title: "Referencia",
      icon: <FaFileContract />,
      color: "linear-gradient(135deg, #0081cf, #00c6ff)",
      path: "/referencia",
      desc: "Gestión maestra de especificaciones y catálogos de referencia.",
      permiso: 1,
    },
    {
      title: "Seguimiento",
      icon: <FaClipboardList />,
      color: "linear-gradient(135deg, #10b981, #34d399)",
      desc: "Trazabilidad completa de procesos y control de cambios operativos.",
      permiso: 1,
    },
    {
      title: "Certificados",
      icon: <FaSignature />,
      color: "linear-gradient(135deg, #f59e0b, #fbbf24)",
      path: "/firmacert",
      desc: "Validación digital y firma autorizada para certificados de inspección.",
      permiso: permisoUser?.permiso?.certificado,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <h1 className={styles.title}>Registro y Control</h1>
        <p className={styles.titleDescription}>
          Supervisión integral de referencias, trazabilidad de procesos y validación oficial de documentos.
        </p>
      </div>

      {loading ? (
        <div className={styles.skeletonGrid}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.skeleton} />
          ))}
        </div>
      ) : (
        <div className={styles.cardGrid}>
          {cards.map((c, i) => {
            const permitido = c.permiso === 1;

            return (
              <div
                key={i}
                className={`${styles.card} ${!permitido ? styles.disabled : ""}`}
                onClick={() => c.path && validar(c.permiso, c.path)}
              >
                <div className={styles.info}>
                  <FaInfoCircle />
                </div>

                <div
                  className={styles.icon}
                  style={{ background: c.color }}
                >
                  {c.icon}
                </div>

                <h3 className={styles.cardTitle}>{c.title}</h3>
                <p className={styles.desc}>{c.desc}</p>

                {permitido ? (
                  <div style={{ marginTop: 'auto', paddingTop: '10px', color: 'var(--secondary)', fontSize: '0.75rem', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    ACCEDER <FaChevronRight style={{ fontSize: '10px' }} />
                  </div>
                ) : (
                  <div className={styles.lock}>
                    <FaLock /> Acceso Bloqueado
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RegistroYControl;
